export default __webpack_public_path__ + "static/media/receiving.716718c9.svg";